// extracted by mini-css-extract-plugin
export default {"inputWrapper":"InputField_inputWrapper__H0OQS","label":"InputField_label__WO4j5"};